var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("交易单管理")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("创建交易单")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "tradeVoucher",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.tradeVoucher, rules: _vm.tradeVoucherRules }
        },
        [
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("关联合同")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "contractTitle" } },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.tradeVoucher.contractTitle,
                          callback: function($$v) {
                            _vm.$set(_vm.tradeVoucher, "contractTitle", $$v)
                          },
                          expression: "tradeVoucher.contractTitle"
                        }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass:
                          "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                        on: { click: _vm.contractSelect }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("交易类型")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: "", placeholder: "请选择" },
                      model: {
                        value: _vm.tradeVoucher.type,
                        callback: function($$v) {
                          _vm.$set(_vm.tradeVoucher, "type", $$v)
                        },
                        expression: "tradeVoucher.type"
                      }
                    },
                    _vm._l(_vm.tradeTypeList, function(tradeType) {
                      return _c("el-option", {
                        key: tradeType.value,
                        attrs: {
                          label: tradeType.label,
                          value: tradeType.value
                        }
                      })
                    })
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("买家")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("买家名称")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.tradeVoucher.buyerName))])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("卖家")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("卖家名称")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [_vm._v(_vm._s(_vm.tradeVoucher.sellerName))])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", { staticClass: "type required" }, [_vm._v("支付信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("付款时机")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "ul",
                  { staticClass: "enum-list" },
                  _vm._l(_vm.merchantPayTimingList, function(
                    merchantPayTiming,
                    index
                  ) {
                    return _c(
                      "li",
                      {
                        staticClass: "enum-item",
                        class: {
                          checked:
                            _vm.tradeVoucher.payTiming ==
                            merchantPayTiming.value
                        },
                        on: {
                          click: function($event) {
                            _vm.selectPayTiming(merchantPayTiming, index)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(merchantPayTiming.name) +
                            "\n                            "
                        ),
                        _c("i")
                      ]
                    )
                  })
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("支付方式")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c(
                  "ul",
                  { staticClass: "enum-list" },
                  [
                    _vm.contract != null && _vm.contract.id != null
                      ? _c(
                          "li",
                          {
                            staticClass: "enum-item",
                            class: { checked: true }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.tradeVoucher.payWayText) +
                                "\n                            "
                            ),
                            _c("i")
                          ]
                        )
                      : _vm._l(_vm.payWayList, function(payWay, index) {
                          return _c(
                            "li",
                            {
                              staticClass: "enum-item",
                              class: {
                                checked: _vm.tradeVoucher.payWay == payWay.value
                              },
                              on: {
                                click: function($event) {
                                  _vm.selectPayWay(payWay, index)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(payWay.name) +
                                  "\n                            "
                              ),
                              _c("i")
                            ]
                          )
                        })
                  ],
                  2
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("交易总金额")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "totalZxAmount" } },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.tradeVoucher.totalZxAmount,
                          callback: function($$v) {
                            _vm.$set(_vm.tradeVoucher, "totalZxAmount", $$v)
                          },
                          expression: "tradeVoucher.totalZxAmount"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("索要发票")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", {}, [_vm._v("是否索要发票")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: {
                        disabled:
                          _vm.contract != null && _vm.contract.id != null
                      },
                      model: {
                        value: _vm.tradeVoucher.invoiceClaimed,
                        callback: function($$v) {
                          _vm.$set(_vm.tradeVoucher, "invoiceClaimed", $$v)
                        },
                        expression: "tradeVoucher.invoiceClaimed"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("是")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("否")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.tradeVoucher.invoiceClaimed
            ? _c("div", { staticClass: "simple-form" }, [
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", {}, [_vm._v("收货时段")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c(
                      "ul",
                      { staticClass: "enum-list" },
                      _vm._l(_vm.recvFrameList, function(recvFrame, index) {
                        return _c(
                          "li",
                          {
                            staticClass: "enum-item",
                            class: {
                              checked:
                                _vm.tradeVoucher.recvFrame == recvFrame.value
                            },
                            on: {
                              click: function($event) {
                                _vm.selectRecvFrame(recvFrame, index)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(recvFrame.text) +
                                "\n                                "
                            ),
                            _c("i")
                          ]
                        )
                      })
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", {}, [_vm._v("发票类型")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c(
                      "ul",
                      { staticClass: "enum-list" },
                      _vm._l(_vm.merchantInvoiceTypeList, function(
                        merchantInvoiceType,
                        index
                      ) {
                        return _c(
                          "li",
                          {
                            staticClass: "enum-item",
                            class: {
                              checked:
                                _vm.tradeVoucher.invoiceType ==
                                merchantInvoiceType.value
                            },
                            on: {
                              click: function($event) {
                                _vm.selectInvoiceType(
                                  merchantInvoiceType,
                                  index
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(merchantInvoiceType.name) +
                                "\n                                "
                            ),
                            _c("i")
                          ]
                        )
                      })
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", {}, [_vm._v("发票主体类型")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c(
                      "ul",
                      { staticClass: "enum-list" },
                      _vm._l(_vm.merchantInvoiceSubjectTypeList, function(
                        merchantInvoiceSubjectType,
                        index
                      ) {
                        return _c(
                          "li",
                          {
                            staticClass: "enum-item",
                            class: {
                              checked:
                                _vm.tradeVoucher.invoiceSubjectType ==
                                merchantInvoiceSubjectType.value
                            },
                            on: {
                              click: function($event) {
                                _vm.selectInvoiceSubjectType(
                                  merchantInvoiceSubjectType,
                                  index
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(merchantInvoiceSubjectType.text) +
                                "\n                                "
                            ),
                            _c("i")
                          ]
                        )
                      })
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", {}, [_vm._v("发票内容标签")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c(
                      "ul",
                      { staticClass: "enum-list" },
                      _vm._l(_vm.merchantInvoiceCtntTagList, function(
                        merchantInvoiceCtntTag,
                        index
                      ) {
                        return _c(
                          "li",
                          {
                            staticClass: "enum-item",
                            class: {
                              checked:
                                _vm.tradeVoucher.invoiceContentTag ==
                                merchantInvoiceCtntTag.name
                            },
                            on: {
                              click: function($event) {
                                _vm.selectIvoiceContentTag(
                                  merchantInvoiceCtntTag,
                                  index
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(merchantInvoiceCtntTag.name) +
                                "\n                                "
                            ),
                            _c("i")
                          ]
                        )
                      })
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", {}, [_vm._v("发票抬头")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        model: {
                          value: _vm.tradeVoucher.invoiceTitle,
                          callback: function($$v) {
                            _vm.$set(_vm.tradeVoucher, "invoiceTitle", $$v)
                          },
                          expression: "tradeVoucher.invoiceTitle"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", {}, [_vm._v("纳税人识别号")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        model: {
                          value: _vm.tradeVoucher.taxPayerNo,
                          callback: function($$v) {
                            _vm.$set(_vm.tradeVoucher, "taxPayerNo", $$v)
                          },
                          expression: "tradeVoucher.taxPayerNo"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bc09a32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bc09a32","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/tradeVoucher/TradeVoucherAdd.vue
// module id = 2807
// module chunks = 0